import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormForDocumentUpload from "../../components/dynamicscreens/DynamicFormForDocumentUpload";
import { withRouter } from "../../components/withRouter";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { noticeMessageJSON } from "../../DynamicFormsJson/Transaction/noticeMessage";
import { getRegionNew, getZoneByRegionIds } from "../../Slice/region.slice";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import { getAreaByZoneIds } from "../../Slice/area.slice";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { Box, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup } from "@mui/material";
import { LabelCompo } from "../../components/Comman/Label";
import { redColor, titleColor } from "../../config/ColorObj";

class NoticeMessageEditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                regionDetail: this.props.regionList?.region,
                zoneDetail: this.props.regionList?.zone,
                areaDetail: this.props.zoneList?.area,
                stakeHolderTypeDetail:
                    this.props.stakeHolderTypeList?.stockStakeHolderType,
            },
            value: 0,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.stakeHolderTypeList !== nextProps.stakeHolderTypeList) {
            if (
                this.props.stakeHolderTypeList?.stockStakeHolderType !==
                nextProps.stakeHolderTypeList?.stockStakeHolderType
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        stakeHolderTypeDetail:
                            nextProps.stakeHolderTypeList?.stockStakeHolderType,
                    },
                });
            }
        }

        if (this.props.regionList !== nextProps.regionList) {
            if (this.props.regionList?.region !== nextProps.regionList?.region) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        regionDetail: nextProps.regionList?.region,
                    },
                });
            }
        }

        if (this.props.regionList !== nextProps.regionList) {
            if (this.props.regionList?.zone !== nextProps.regionList?.zone) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        zoneDetail: nextProps.regionList?.zone,
                    },
                });
            }
        }

        if (this.props.areaList !== nextProps.areaList) {
            if (this.props.areaList?.area !== nextProps.areaList?.area) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        areaDetail: nextProps.areaList?.area,
                    },
                });
            }
        }
    }

    async componentDidMount() {
        const { getRegionNew, showLoador, showNotification, getStockStakeHolderType } =
            this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            await getStockStakeHolderType({ userTypeIds: "2,3,4" }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });

            showLoador({ loador: true });
            await getRegionNew().then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    getListById = async (data) => {
        const {
            getZoneByRegionIds,
            getAreaByZoneIds,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {
            if (data.regionIds && data.regionIds != "") {
                showLoador({ loador: true });
                await getZoneByRegionIds({ regionId: data.regionIds }).then(
                    ({ success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }

            if (data.zoneIds && data.zoneIds != "") {
                showLoador({ loador: true });
                await getAreaByZoneIds({ zoneIds: data.zoneIds }).then(
                    ({ success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    getDataById = ({ id }) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            const response = apiGet({
                url: noticeMessageJSON.apiBaseURL + "/" + id,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    if (!data.error) {
                        let rowData = data.data;
                        let isPanIndia = rowData.isPanIndia !== null ? rowData.isPanIndia : 0;
                        this.setState({ value: isPanIndia })
                        let dataToSet = {
                            ...rowData,
                        };
                        return { response: dataToSet, success };
                    } else {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                    return { response: {}, success: false };
                }
                return { response: {}, success: false };
            });
            return response;
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        });
    };

    onCancel = () => {
        this.props.navigate(-1);
    };

    render() {
        const { dynamicMasterData, value } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        borderRadius: 2,
                        p: 2,
                    }}
                    elevation={0}
                >
                    <LandingScreenHeader
                        screenTitle={"Notice / Message"}
                        showTable={false}
                        showBackButton={true}
                        showAddButton={false}
                        onCancel={this.onCancel}
                    />
                    <br />

                    {localStorage.getItem("isPanIndiaNotice") && localStorage.getItem("isPanIndiaNotice") == 1 && (

                        <Box sx={{ width: '100%', minWidth: 600 }}>
                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                                wrap="nowrap"
                            >
                                {/* Label Section */}
                                <Grid
                                    item
                                    style={{ minWidth: 170, marginLeft: 18 }}
                                >
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: redColor }}
                                        label={"*"}
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{
                                            fontSize: 16,
                                            color: titleColor,
                                        }}
                                        label={"Is Notice For :"}
                                    />
                                </Grid>

                                {/* Radio Buttons Section */}
                                <Grid
                                    item
                                    style={{ marginLeft: 60, minWidth: 200 }}
                                >
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={value}
                                            onChange={this.handleChange}
                                            row
                                            defaultValue={value}
                                        >
                                            <FormControlLabel
                                                value={0}
                                                control={<Radio />}
                                                label="Area Wise"
                                            />
                                            <FormControlLabel
                                                value={1}
                                                control={<Radio />}
                                                label="Pan India"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    <DynamicFormForDocumentUpload
                        formPath={noticeMessageJSON.formPath}
                        getListById={this.getListById}
                        fieldMeta={
                            value == 0 ?
                                noticeMessageJSON.fieldMetaForEditAreaWise :
                                localStorage.getItem("isPanIndiaNotice") &&
                                    localStorage.getItem("isPanIndiaNotice") == 1 ?
                                    noticeMessageJSON.fieldMetaForEditForPanIndia :
                                    noticeMessageJSON.fieldMetaForEditAreaWise
                        }
                        dynamicMasterData={dynamicMasterData}
                        apiBaseURL={noticeMessageJSON.apiBaseURL}
                        showSaveNextBtn={noticeMessageJSON.showSaveNextBtn}
                        callGetByIdApi={false}
                        getByIdApi={this.getDataById}
                        isEditURL={noticeMessageJSON.isEditURL}
                        isPanIndia={value == 0 ? 0 :
                            localStorage.getItem("isPanIndiaNotice") &&
                                localStorage.getItem("isPanIndiaNotice") == 1 ? 1 : 0}
                        isLog={true}
                        type={0}
                    />
                </Paper>

            </>
        );
    }
}
const mapStateToProps = (state) => ({
    areaList: state.area,
    regionList: state.region,
    stakeHolderTypeList: state.stockStakeHolderType,
    stateList: state.states,
    districtList: state.district,
    talukaList: state.taluka,
});
const mapDispatchToProps = {
    getAreaByZoneIds,
    getRegionNew,
    getZoneByRegionIds,
    getStockStakeHolderType,
    showLoador,
    showNotification,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(NoticeMessageEditForm);